import * as React from 'react';
import { useSelector } from 'react-redux';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { Header as HeaderComponent } from '../../components/Header';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { getDeveloperName } from '../../selectors/developerV2/';
import { CallRedesigned } from '../Call';
import { CallbackButtonContainer } from '../CallbackButtonRedesigned';
import { trackShowPhone } from '../ContactButtonsRedesigned/tracking';
import { getDeveloperHeaderLogo } from '../../selectors/developerV2/getDeveloperHeaderLogo';

interface IHeaderProps {
  isFixed: boolean;
}

export const Header = ({ isFixed }: IHeaderProps) => {
  const developerName = useSelector(getDeveloperName);
  const name = `Застройщик ${developerName}`;

  const developerHeaderLogo = useSelector(getDeveloperHeaderLogo);

  const handleShowPhone = React.useCallback((id: number) => {
    setTimeout(() => trackShowPhone('Open_card_builder_blockStickytop')(id), 0);
  }, []);

  return (
    <HeaderComponent
      logoSrc={developerHeaderLogo}
      name={name}
      isFixed={isFixed}
      call={
        <SPThemeWrapper>
          <CallRedesigned
            onShowPhone={handleShowPhone}
            showPhoneStyles={{
              fullWidth: true,
              size: 'XS',
              beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
            }}
            openContactsStyles={{ fullWidth: true, size: 'XS' }}
          />
        </SPThemeWrapper>
      }
      callback={<CallbackButtonContainer fullWidth={true} place="blockStickytop" size="XS" theme="fill_secondary" />}
    />
  );
};
